export enum IssueOrderBy {
  CREATED_AT = 'created_at',
  PRIORITY = 'priority',
}

export enum IssueOrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const ORDER_ITEMS = [
  { label: 'Created at', value: IssueOrderBy.CREATED_AT },
  { label: 'Priority', value: IssueOrderBy.PRIORITY },
];

export const ISSUE_TYPE_ITEMS = [
  { label: 'Show all', value: 'All' },
  { label: 'Bugs', value: 'Bug' },
  { label: 'Feature requests', value: 'Feature Request' },
];

export enum WORK_STATUSES_DISPLAY {
  notStarted = 'Not Started',
  planned = 'Planned',
  inProgress = 'In Progress',
}

export enum RESOLUTION_STATUSES_DISPLAY {
  resolved = 'Resolved',
  wontDo = "Won't Do",
  duplicate = 'Duplicate',
  cannotReproduce = 'Cannot Reproduce',
}
